exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-uploader .el-upload {\r\n    border: 1px dashed #d9d9d9;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    position: relative;\r\n    overflow: hidden;\n}\n.avatar-uploader .el-upload:hover {\r\n    border-color: #409eff;\n}\n.avatar {\r\n    width: 178px;\r\n    height: 178px;\r\n    display: block;\n}\n.img-center {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    left: 0;\r\n    top: 0;\r\n    -o-object-fit: contain;\r\n       object-fit: contain\n}\n.hide .el-upload--picture-card {\r\n    display: none;\n}\r\n\r\n", ""]);

// exports
